var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("month-history-loads", {
    attrs: {
      loads: _vm.loadHistoryForMonth,
      company: _vm.company,
      loading: _vm.loadingLoadHistory,
      accurateSince: _vm.loadHistoryTimestamp,
      history: ""
    },
    on: {
      selectMonth: function($event) {
        return _vm.loadHistory($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-730b9dcb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730b9dcb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/HistorySection.vue
// module id = null
// module chunks = 